/* CY FORM (2026-09-28) — behaviour for sections/cy-support-form.liquid (blocks _cy-form, _cy-form-field).
   US-only store. Researched rules (Baymard inline validation, USWDS, NN/g error messages):
   - check a field when the customer LEAVES it (never while they are still typing); once it shows an error,
     re-check on every keystroke so the error clears the moment it is fixed;
   - on Submit: check everything, show each error under its field, move focus to the first one and prefix the
     tab title with "Error:" for screen readers;
   - Phone formats itself as 555-555-5555 (a leading 1 is dropped); ZIP takes 5 digits or ZIP+4; links get
     https:// added; Month / Day / Year boxes are sent as one MM/DD/YYYY answer;
   - "Show only when" fields appear/disappear with the answer they depend on; while hidden they are disabled
     (not required, not sent);
   - choice chips light up when picked (the locked button component's dark state); "pick any" answers are sent
     as one comma-separated line;
   - side panel: open on wide screens, collapsed on phones. */
(function () {
  'use strict';
  if (window.CyForms) return; window.CyForms = true;

  var PHONE = /^\d{3}-\d{3}-\d{4}$/, ZIP = /^\d{5}(-\d{4})?$/, EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function formatTel(v) {
    var d = v.replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    d = d.slice(0, 10);
    if (d.length > 6) return d.slice(0, 3) + '-' + d.slice(3, 6) + '-' + d.slice(6);
    if (d.length > 3) return d.slice(0, 3) + '-' + d.slice(3);
    return d;
  }
  function formatZip(v) {
    var d = v.replace(/\D/g, '').slice(0, 9);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }
  function lower(s) { return s.charAt(0).toLowerCase() + s.slice(1); }

  function init(form) {
    if (form.dataset.cyfReady) return; form.dataset.cyfReady = '1';
    form.noValidate = true;
    var fields = [].slice.call(form.querySelectorAll('[data-cyf-field]'));
    var byLabel = {};
    fields.forEach(function (w) { if (w.dataset.label) byLabel[w.dataset.label.toLowerCase()] = w; });

    function answer(w) {
      if (!w) return [];
      var t = w.dataset.type;
      if (t === 'radio') { var c = w.querySelector('input:checked'); return c ? [c.value] : []; }
      if (t === 'checkboxes') return [].slice.call(w.querySelectorAll('input[type=checkbox]:checked')).map(function (i) { return i.value; });
      if (t === 'consent') { var k = w.querySelector('input'); return k && k.checked ? ['Yes'] : []; }
      var el = w.querySelector('select, input:not([type=hidden]), textarea');
      if (!el || !el.value) return [];
      /* a product dropdown also answers with its group name, so "Show only when Product is Gaming Chairs"
         matches every chair */
      if (el.tagName === 'SELECT' && el.selectedOptions[0] && el.selectedOptions[0].parentNode.tagName === 'OPTGROUP') return [el.value, el.selectedOptions[0].parentNode.label];
      return [el.value];
    }

    /* ---- conditions ---- */
    function applyConditions() {
      fields.forEach(function (w) {
        if (!w.dataset.showIf) return;
        var src = byLabel[w.dataset.showIf.toLowerCase()];
        var want = w.dataset.showIs.split('|').map(function (s) { return s.trim().toLowerCase(); });
        var srcHidden = src && src.hidden;
        var on = !srcHidden && answer(src).some(function (a) { return want.indexOf(a.toLowerCase()) > -1; });
        if (w.hidden === !on) return;
        w.hidden = !on;
        if ('disabled' in w) w.disabled = !on;
        if (!on) clearError(w);
      });
    }

    /* ---- errors ---- */
    function setError(w, msg) {
      var e = w.querySelector('[data-cyf-err]'); if (!e) return;
      e.textContent = msg; e.hidden = false; w.classList.add('is-invalid'); w.classList.remove('is-valid');
      w.querySelectorAll('input:not([type=hidden]), select, textarea').forEach(function (i) { i.setAttribute('aria-invalid', 'true'); });
    }
    function clearError(w) {
      var e = w.querySelector('[data-cyf-err]'); if (e) { e.hidden = true; e.textContent = ''; }
      w.classList.remove('is-invalid');
      w.querySelectorAll('[aria-invalid]').forEach(function (i) { i.removeAttribute('aria-invalid'); });
    }
    function emptyMsg(w) {
      if (w.dataset.msg) return w.dataset.msg;
      var l = (w.dataset.label || '').replace(/\s*\*$/, ''), t = w.dataset.type;
      if (t === 'consent') return 'Tick this box to continue.';
      if (/\?$/.test(l)) return (t === 'radio' || t === 'select' || t === 'checkboxes') ? 'Choose an answer.' : 'Answer this question.';
      if (t === 'product') return 'Choose your product.';
      if (t === 'state') return 'Choose your state.';
      if (t === 'tel') return 'Enter your phone number.';
      if (t === 'checkboxes') return 'Choose at least one option.';
      if (t === 'select' || t === 'radio') return 'Choose an option.';
      if (t === 'date') return 'Enter the ' + lower(l) + '.';
      return 'Enter your ' + lower(l) + '.';
    }
    /* returns '' when fine */
    function check(w) {
      if (w.hidden || w.disabled || !w.dataset.type) return '';
      var t = w.dataset.type, req = w.hasAttribute('data-required'), val = answer(w);
      if (t === 'date') return checkDate(w, req);
      if (!val.length || !String(val[0]).trim()) return req ? emptyMsg(w) : '';
      var v = String(val[0]).trim();
      if (t === 'email' && !EMAIL.test(v)) return 'Enter an email address like name@example.com.';
      if (t === 'tel' && !PHONE.test(v)) return 'Enter a 10-digit US phone number, like 555-555-5555.';
      if (t === 'zip' && !ZIP.test(v)) return 'Enter a 5-digit ZIP code, like 90210.';
      if (t === 'url' && !/^https?:\/\/[^\s.]+\.[^\s]{2,}/i.test(v)) return 'Enter a link, like youtube.com/@yourchannel.';
      if (t === 'number' && !/^\d+$/.test(v)) return 'Enter a number, digits only.';
      return '';
    }
    function checkDate(w, req) {
      var m = w.querySelector('[data-cyf-date=m]').value, d = w.querySelector('[data-cyf-date=d]').value.trim(), y = w.querySelector('[data-cyf-date=y]').value.trim();
      if (!m && !d && !y) return req ? emptyMsg(w) : '';
      if (!m || !d || !y) return 'Enter the month, day and year.';
      var yy = +y, mm = +m, dd = +d, now = new Date();
      if (/^\d{4}$/.test(y) && yy > now.getFullYear()) return 'The date can\'t be in the future.';
      if (!/^\d{4}$/.test(y) || yy < 2015) return 'Enter a 4-digit year, like ' + now.getFullYear() + '.';
      var dt = new Date(yy, mm - 1, dd);
      if (!/^\d{1,2}$/.test(d) || dt.getMonth() !== mm - 1 || dt.getDate() !== dd) return 'Enter a real date.';
      if (dt > now) return 'The date can\'t be in the future.';
      return '';
    }
    function validate(w, showOk) {
      var msg = check(w);
      if (msg) setError(w, msg); else { clearError(w); if (showOk && answer(w).length) w.classList.add('is-valid'); }
      return !msg;
    }

    /* ---- inputs ---- */
    function sync(w) {
      var t = w.dataset.type;
      if (t === 'checkboxes') {
        var h = w.querySelector('[data-cyf-multi]'); if (h) h.value = answer(w).join(', ');
      }
      if (t === 'radio' || t === 'checkboxes') {
        w.querySelectorAll('.cyf-choice').forEach(function (l) { l.classList.toggle('is-active', l.querySelector('input').checked); });
      }
      if (t === 'date') {
        var m = w.querySelector('[data-cyf-date=m]').value, d = w.querySelector('[data-cyf-date=d]').value.trim(), y = w.querySelector('[data-cyf-date=y]').value.trim();
        w.querySelector('[data-cyf-date-value]').value = (m && d && y) ? m + '/' + (d.length === 1 ? '0' + d : d) + '/' + y : '';
      }
    }
    fields.forEach(function (w) {
      if (!w.dataset.type) return;
      var t = w.dataset.type;
      var el = w.querySelector('input:not([type=hidden]):not([type=radio]):not([type=checkbox]), textarea, select');
      w.addEventListener('input', function (e) {
        var i = e.target;
        if (t === 'tel' && i.value) { var pos = i.value.length === i.selectionStart; i.value = formatTel(i.value); if (pos) i.setSelectionRange(i.value.length, i.value.length); }
        if (t === 'zip' && i.value) i.value = formatZip(i.value);
        if (i.dataset.cyfDate === 'd' || i.dataset.cyfDate === 'y') i.value = i.value.replace(/\D/g, '');
        sync(w);
        if (w.classList.contains('is-invalid')) validate(w, false);
        w.classList.remove('is-valid');
      });
      w.addEventListener('change', function () {
        sync(w); applyConditions();
        if (t === 'radio' || t === 'checkboxes' || t === 'select' || t === 'product' || t === 'state' || t === 'consent') validate(w, false);
      });
      /* leaving the field (for grouped fields: leaving the whole group) */
      w.addEventListener('focusout', function (e) {
        if (w.contains(e.relatedTarget)) return;
        if (t === 'url' && el && el.value.trim() && !/^https?:\/\//i.test(el.value.trim())) el.value = 'https://' + el.value.trim().replace(/^\/+/, '');
        if (el && el.value !== undefined && typeof el.value === 'string' && el.tagName !== 'SELECT') el.value = el.value.replace(/^\s+|\s+$/g, '');
        var touched = answer(w).length || w.classList.contains('is-invalid');
        if (t === 'date') touched = [].some.call(w.querySelectorAll('[data-cyf-date]'), function (i) { return i.value; });
        if (touched) validate(w, t === 'email' || t === 'tel' || t === 'zip' || t === 'url');
      });
      sync(w);
    });
    applyConditions();

    /* ---- submit ---- */
    var title = document.title;
    form.addEventListener('submit', function (e) {
      fields.forEach(sync); applyConditions();
      var bad = fields.filter(function (w) { return !validate(w, false); });
      if (bad.length) {
        e.preventDefault();
        document.title = 'Error: ' + title;
        var first = bad[0].querySelector('input:not([type=hidden]), select, textarea');
        bad[0].scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 250);
        return;
      }
      document.title = title;
      var btn = form.querySelector('[data-cyf-submit]');
      if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); setTimeout(function () { btn.disabled = true; }, 0); }
      /* the success screen's "Email photos" button gets a subject the team can match (2026-10-24): kept in this tab only */
      try { var pick = function (re) { var w = fields.filter(function (x) { return re.test(x.dataset.label || '') && !x.hidden; })[0]; return w ? answer(w).join(', ') : ''; };
        sessionStorage.setItem('cyf-last', JSON.stringify({ order: pick(/^order number$/i), serial: pick(/^serial number$/i), company: pick(/^company/i), name: pick(/^full name$/i) })); } catch (x) {}
    });
  }

  function aside() {
    var phone = matchMedia('(max-width: 989px)');
    document.querySelectorAll('[data-cyf-aside]').forEach(function (d) {
      if (d.dataset.cyfReady) return; d.dataset.cyfReady = '1';
      /* phones: open unless the block's "Open on phones" is off (owner 2026-10-24: "Have these ready" should be open by default on phone) */
      d.open = !phone.matches || d.dataset.cyfOpenPhone !== 'false';
      d.querySelector('summary').addEventListener('click', function (e) { if (!phone.matches) e.preventDefault(); });
    });
  }
  function done() {
    var d = document.querySelector('[data-cyf-done]');
    /* "Warranty claim · Order #1198 · Chris Walker" on the email button (answers saved at submit, this tab only) */
    if (d) { var m = d.querySelector('[data-cyf-mail]'); if (m) { try { var a = JSON.parse(sessionStorage.getItem('cyf-last') || '{}');
      var subj = [m.getAttribute('data-form'), a.order ? 'Order ' + a.order : a.serial ? 'Serial ' + a.serial : a.company, a.name].filter(Boolean).join(' · ');
      m.href = m.href.split('?')[0] + '?subject=' + encodeURIComponent(subj); } catch (x) {} } }
    if (d) { d.scrollIntoView({ block: 'center' }); d.focus({ preventScroll: true }); }
  }
  function all() { document.querySelectorAll('form.cyf, form[data-cyf]').forEach(init); aside(); done(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', all);
})();
/* Back/forward cache: the page returns with the submit button still busy from the last submit */
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  document.querySelectorAll('[aria-busy="true"]').forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); b.classList.remove('is-busy'); });
});
